export const CONTEXT_SOURCE_FIELD_VALUE_MONIKER_DELIMITER = '__';

export const formatContextSourceFieldValueMonikerId = ({
  contextSourceFieldValueId,
  contextSourceId,
}: {
  contextSourceFieldValueId: string;
  contextSourceId: string;
}): string => `${contextSourceId}${CONTEXT_SOURCE_FIELD_VALUE_MONIKER_DELIMITER}${contextSourceFieldValueId}`;

export const parseContextSourceFieldValueMonikerId = (
  monikerId: string,
): { contextSourceFieldValueId: string; contextSourceId: string } | null => {
  const delimiterIndex = monikerId.indexOf(CONTEXT_SOURCE_FIELD_VALUE_MONIKER_DELIMITER);

  if (
    delimiterIndex <= 0 ||
    delimiterIndex === monikerId.length - CONTEXT_SOURCE_FIELD_VALUE_MONIKER_DELIMITER.length
  ) {
    return null;
  }

  const contextSourceId = monikerId.slice(0, delimiterIndex);
  const contextSourceFieldValueId = monikerId.slice(
    delimiterIndex + CONTEXT_SOURCE_FIELD_VALUE_MONIKER_DELIMITER.length,
  );

  if (!contextSourceId || !contextSourceFieldValueId) {
    return null;
  }

  return { contextSourceFieldValueId, contextSourceId };
};
